import { createRouter, createWebHistory } from "vue-router";
import { authMiddleware, guardMiddleware, titleMiddleware } from "./routeMiddleware";

//Template Auth
import TemplateAuth from "@/layouts/TemplateAuth.vue";


//Auth
import Login from "@/views/auth/Login.vue";

//Conversation 

import Inbox from "@/views/inbox/Inbox.vue"
import Show from "@/views/conversation/Show.vue"
// import ShowConversation from "@/pages/Conversation/ShowConversation.vue";


const routes = [
    {
        path: "/login",
        meta:{title:"Connexion"},
        children: [

            {
                path: "",
                name: "AuthLogin",

                component: Login
            },
        ]
    },

    {
        path: "/",
        component: TemplateAuth,
        name:"Home",
        meta: { requiredAuth: true,title:"ALIBORA - WEB" },
        children: [
            {
                path: "",
                name: "Inboxs",
                component: Inbox
            },
            
        ]
    },
    {
        // path: "/conversation",
        path: "/conversation/:id",
        meta:{title:"ALIBORA - WEB",requiredAuth:true},
        component:Show,
    }
];


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// routeMiddleware
router.beforeEach(authMiddleware)
router.beforeEach(guardMiddleware)
router.beforeEach(titleMiddleware)




export default router